import FetchStatus from 'src/types/FetchStatus';

const isStatusLoading = (...statusList: FetchStatus[]) => statusList.some(
  (status) => [FetchStatus.idle, FetchStatus.loading].includes(status),
);

export default isStatusLoading;
